/* import __COLOCATED_TEMPLATE__ from './project-cancellation-details.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import {
  PROJECT_CANCELLATION__CANCELLATION_REASONS,
  PROJECT_CANCELLATION__QUERY_PARAMS
} from "sh-www/constants/routes/project-cancellation";
import { EMBER_ROUTE_NAMES } from "sh-www/constants/routes";

const CLASS_NAME = 'SH-c-project-cancellation-details';

export default class ProjectCancellationDetails extends Component {
  @service router;

  @tracked additionalInformationNotes = '';
  @tracked projectCancellationReason = null;

  get constantsCancellationReasons() {
    return PROJECT_CANCELLATION__CANCELLATION_REASONS;
  }

  get className() {
    return CLASS_NAME;
  }

  get isContinueButtonDisabled() {
    return !this.projectCancellationReason;
  }

  @action
  onBackClicked() {
    this.router.transitionTo(EMBER_ROUTE_NAMES.PROJECT__CANCELLATION__CONFIRM, this.args.application.id);
  }

  @action
  onContinueClicked() {
    this.router.transitionTo(EMBER_ROUTE_NAMES.PROJECT__CANCELLATION__PAYMENT, this.args.application.id, {
      queryParams: {
        [PROJECT_CANCELLATION__QUERY_PARAMS.PROJECT_CANCELLATION_REASON]: this.projectCancellationReason,
        [PROJECT_CANCELLATION__QUERY_PARAMS.ADDITIONAL_INFORMATION_NOTES]: this.additionalInformationNotes
      }
    });
  }

  @action
  onSelectCancellationReasonClicked(cancellationReason) {
    this.projectCancellationReason = cancellationReason;
  }

  @action
  onUpdateAdditionalInformationNotes(value) {
    this.additionalInformationNotes = value;
  }
}
